export const DEFAULT_STANDARD_RECORDING_TIME_HOURS = 48;
export const DEFAULT_REVIEW_TIMEFRAME_DAYS = 365;
export const DEFAULT_LANGUAGE = 'de';
export const DEFAULT_HIGH_MODEL = 'gpt-6.1-sol';
export const DEFAULT_LOW_MODEL = 'gpt-6-luna';
export const DEFAULT_TRANSCRIPTION_MODEL = 'gpt-4o-transcribe';
export const DEFAULT_BILLING_RATE = 110;
export const DEFAULT_PRIVACY_MODE = 'need-to-know';
/**
 * Data zones a deployment may process data in. `global` is for models Azure
 * offers without a Data Zone deployment (Claude).
 */ export const AI_DATA_ZONES = [
    'eu',
    'global'
];
/**
 * Azure regions the platform has a resource in, each configured as
 * `AZURE_<REGION>_BASE_URL` + `AZURE_<REGION>_API_KEY`. One resource can host
 * deployments of different data zones.
 */ export const AI_AZURE_REGIONS = [
    'germanywestcentral',
    'swedencentral'
];
/** The gpt-6 deployments differ only in name and reasoning range. */ function gpt6Config(deployment, label, reasoningEfforts) {
    return {
        deployment,
        provider: 'openai',
        region: 'germanywestcentral',
        dataZone: 'eu',
        label,
        reasoningEfforts,
        // Calls reason more only when a setting asks for it.
        defaultReasoningEffort: reasoningEfforts[0],
        supportsTemperature: false,
        supportsPdfInput: true,
        contextWindow: 400_000
    };
}
export const AI_MODEL_CONFIGS = {
    'gpt-6.1-sol': gpt6Config('gpt-6.1-sol', 'GPT-6.1 Sol', [
        'low',
        'medium',
        'high',
        'xhigh',
        'max'
    ]),
    'gpt-6-sol': gpt6Config('gpt-6-sol', 'GPT-6 Sol', [
        'none',
        'low',
        'medium',
        'high',
        'xhigh',
        'max'
    ]),
    'gpt-6-luna': gpt6Config('gpt-6-luna', 'GPT-6 Luna', [
        'none',
        'low',
        'medium',
        'high',
        'xhigh',
        'max'
    ]),
    'claude-opus-5-5': {
        deployment: 'claude-opus-5-5',
        provider: 'anthropic',
        region: 'swedencentral',
        dataZone: 'global',
        label: 'Claude Opus 5.5',
        // Always thinks (adaptive thinking cannot be switched off); `medium` is
        // the API default.
        reasoningEfforts: [
            'low',
            'medium',
            'high',
            'xhigh',
            'max'
        ],
        defaultReasoningEffort: 'medium',
        supportsTemperature: false,
        supportsPdfInput: true,
        contextWindow: 1_000_000
    }
};

//# sourceMappingURL=organization-defaults.js.map